import React from 'react';

import { DISMISS } from '@candu-ai/styleguide/selectors';

import { Cross } from './Cross';

/**
 * Represents the SDK close button, since this is a preview we should never have a click handler
 */
export const CloseButton = () => (
  <button
    disabled
    className={`${DISMISS.Wrapper} candu-img-button`}
    type="button"
    aria-label="Close"
    css={{ pointerEvents: 'none' }}
  >
    <Cross className={`${DISMISS.SVG}`} />
  </button>
);
